import { useEffect } from 'react';

// Keeps the screen awake while cooking. Reacquires when the tab comes back
// (the OS drops the lock on tab switch / screen off). Degrades silently
// where unsupported — the feature is a nicety, never a requirement.
export function useWakeLock(active: boolean) {
  useEffect(() => {
    if (!active || !('wakeLock' in navigator)) return;
    let lock: WakeLockSentinel | null = null;
    let released = false;

    const acquire = async () => {
      try {
        lock = await navigator.wakeLock.request('screen');
      } catch {
        /* unsupported or denied — carry on */
      }
    };

    const onVisible = () => {
      if (!released && document.visibilityState === 'visible') acquire();
    };

    acquire();
    document.addEventListener('visibilitychange', onVisible);

    return () => {
      released = true;
      document.removeEventListener('visibilitychange', onVisible);
      lock?.release().catch(() => {});
    };
  }, [active]);
}
